"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  formName: 'my-form',
  successMessage: 'Success',
  errorMessage: 'Something went wrong'
};
exports["default"] = _default;